import { ISaltWaterDisposalWell } from '../../interfaces/isalt-water-disposal-well';
import { Asset } from '../asset';
import { SaltWaterDisposalFacility } from '../salt-water-disposal-facility';
import { SaltWaterDisposalWellStatus } from '../salt-water-disposal-well-status';

export class SaltWaterDisposalWellBase {
  SaltWaterDisposalWellId: number;
  Name: string | null;
  AssetTeamId: number | null;
  SaltWaterDisposalWellStatusId: number | null;
  AssetId: number | null;
  ExpansionId: number | null;
  MaxStorageCapacity: number | null;
  CurrentVolume: number | null;
  ParentSaltWaterFacilityId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Asset?: Asset;
  SaltWaterDisposalWellStatus?: SaltWaterDisposalWellStatus;
  SaltWaterDisposalFacility?: SaltWaterDisposalFacility;

  constructor(item?: ISaltWaterDisposalWell) {
    if (item) {

      this.SaltWaterDisposalWellId = item.SaltWaterDisposalWellId;
      this.Name = item.Name;
      this.AssetTeamId = item.AssetTeamId;
      this.SaltWaterDisposalWellStatusId = item.SaltWaterDisposalWellStatusId;
      this.AssetId = item.AssetId;
      this.ExpansionId = item.ExpansionId;
      this.MaxStorageCapacity = item.MaxStorageCapacity;
      this.CurrentVolume = item.CurrentVolume;
      this.ParentSaltWaterFacilityId = item.ParentSaltWaterFacilityId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Asset = new Asset(item.Asset);
      this.SaltWaterDisposalWellStatus = new SaltWaterDisposalWellStatus(item.SaltWaterDisposalWellStatus);
      this.SaltWaterDisposalFacility = new SaltWaterDisposalFacility(item.SaltWaterDisposalFacility);
    }
  }
}